// Tags every event arriving from the sim adapter with a monotonic id, so
// consumers (notably `EventLog`) can key by a stable identifier instead of
// `${type}-${i}` over a windowed slice — that windowed-slice pattern
// collapsed repeated same-type events to identical React keys and produced
// ~50 "two children with the same key" console errors per tick.
// (Audit 2026-07-16, finding B3.)
//
// `reset()` is called on match start (bootSim's cleanup) so per-match
// event ids start at zero; that's not load-bearing but it keeps ids
// short for debugging.

export interface RawSimEvent {
  readonly type: string;
  readonly payload?: Record<string, unknown>;
}

export interface TaggedSimEvent extends RawSimEvent {
  readonly id: number;
}

export class EventTagger {
  private nextId = 0;

  tag(raw: RawSimEvent): TaggedSimEvent {
    return { id: this.nextId++, type: raw.type, payload: raw.payload };
  }

  reset(): void {
    this.nextId = 0;
  }
}
